import React from 'react'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

import {generateStyles} from '../../utils/utils'

const TitleBlock = ({Title, TitleAnchorId, TitleBlockTitleStyle}) => {
    return (
        <Box data-block-type="TitleBlock">
            <Text id={TitleAnchorId} {...generateStyles(TitleBlockTitleStyle)} mb={9} pt={5}>
                {Title}
            </Text>
        </Box>
    )
}

TitleBlock.propTypes = {
    Title: PropTypes.string.isRequired,
    TitleAnchorId: PropTypes.string,
    TitleBlockTitleStyle: PropTypes.object
}

export default TitleBlock
